import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import {isMobileApp} from "../helpers/common";

class IPosModal extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    destroyPortal: PropTypes.func,
    modalType: PropTypes.func.isRequired,
    modalProps: PropTypes.object,
    onDestroy: PropTypes.func,
    modalClassName: PropTypes.string,
    disableClickOutside: PropTypes.bool
  };

  static defaultProps = {
    destroyPortal: () => {},
    onDestroy: () => {},
    modalClassName: '',
    disableClickOutside: false
  };

  constructor(props) {
    super(props);
    this.state = { visible: props.visible };
  }

  closeModal = () => {
    this.setState({ visible: false });
    this.props.destroyPortal();
  };

  onClickOutside = (e) => {
    if (!this.props.disableClickOutside) {
      e.stopPropagation();
      e.preventDefault();
      if (this.state.visible) {
        this.props.onDestroy();
        this.closeModal();
      }
    }
  };

  render() {
    if (!this.props.modalType) {
      return null;
    }
    // const SpecifiedModal = MODAL_TYPES[this.props.modalType];
    const SpecifiedModalContent = this.props.modalType;
    return (
      <Modal
        isOpen={ this.state.visible }
        // onRequestClose={ this.closeModal }
        contentLabel="Modal"
        ariaHideApp={ false }
        portalClassName={`ReactModalPortal ${isMobileApp() ? 'mobile_app': ''} `}
        className={ `ipos-modal ${this.props.modalClassName}` }
      >
        {/*<ClickOutside onClickOutside={ this.onClickOutside } >*/}
          <SpecifiedModalContent
            closeModal={ this.closeModal }
            { ...this.props.modalProps }
          />
        {/*</ClickOutside>*/}
      </Modal>
    );
  }
}

export default IPosModal;
